export var icons = {
    layouts_collage: function () { return require('../assets/layouts/collage.svg').ReactComponent; },
    layouts_masonry: function () { return require('../assets/layouts/masonry.svg').ReactComponent; },
    layouts_grid: function () { return require('../assets/layouts/grid.svg').ReactComponent; },
    layouts_thumbnail: function () {
        return require('../assets/layouts/thumbnail.svg').ReactComponent;
    },
    layouts_slider: function () { return require('../assets/layouts/slider.svg').ReactComponent; },
    layouts_slideshow: function () {
        return require('../assets/layouts/slideshow.svg').ReactComponent;
    },
    layouts_strip: function () { return require('../assets/layouts/strip.svg').ReactComponent; },
    layouts_column: function () { return require('../assets/layouts/column.svg').ReactComponent; },
    layouts_bricks: function () { return require('../assets/layouts/bricks.svg').ReactComponent; },
    layouts_mix: function () { return require('../assets/layouts/mix.svg').ReactComponent; },
    layouts_alternate: function () {
        return require('../assets/layouts/alternate.svg').ReactComponent;
    },
    thumbnailResize_crop: function () {
        return require('../assets/thumbnailResize/crop.svg').ReactComponent;
    },
    thumbnailResize_fit: function () {
        return require('../assets/thumbnailResize/fit.svg').ReactComponent;
    },
    imageRatio_3_1: function () {
        return require('../assets/imageRatio/imageRatio_3-1.svg').ReactComponent;
    },
    imageRatio_16_9: function () {
        return require('../assets/imageRatio/imageRatio_16-9.svg').ReactComponent;
    },
    imageRatio_4_3: function () {
        return require('../assets/imageRatio/imageRatio_4-3.svg').ReactComponent;
    },
    imageRatio_1_1: function () {
        return require('../assets/imageRatio/imageRatio_1-1.svg').ReactComponent;
    },
    imageRatio_3_4: function () {
        return require('../assets/imageRatio/imageRatio_3-4.svg').ReactComponent;
    },
    imageRatio_9_16: function () {
        return require('../assets/imageRatio/imageRatio_9-16.svg').ReactComponent;
    },
    hover_zoomIn: function () {
        return require('../assets/animations/hover/zoomIn.svg').ReactComponent;
    },
    hover_blur: function () {
        return require('../assets/animations/hover/blur.svg').ReactComponent;
    },
    hover_grayscale: function () {
        return require('../assets/animations/hover/grayscale.svg').ReactComponent;
    },
    hover_shrink: function () {
        return require('../assets/animations/hover/shrink.svg').ReactComponent;
    },
    hover_invert: function () {
        return require('../assets/animations/hover/invert.svg').ReactComponent;
    },
    hover_color: function () {
        return require('../assets/animations/hover/color.svg').ReactComponent;
    },
    hover_darken: function () {
        return require('../assets/animations/hover/darken.svg').ReactComponent;
    },
    scroll_fadeIn: function () {
        return require('../assets/animations/scroll/fadeIn.svg').ReactComponent;
    },
    scroll_grayscale: function () {
        return require('../assets/animations/scroll/grayscale.svg').ReactComponent;
    },
    scroll_slideUp: function () {
        return require('../assets/animations/scroll/slideUp.svg').ReactComponent;
    },
    scroll_expand: function () {
        return require('../assets/animations/scroll/expand.svg').ReactComponent;
    },
    scroll_shrink: function () {
        return require('../assets/animations/scroll/shrink.svg').ReactComponent;
    },
    scroll_zoomOut: function () {
        return require('../assets/animations/scroll/zoomOut.svg').ReactComponent;
    },
    scroll_oneColor: function () {
        return require('../assets/animations/scroll/oneColor.svg').ReactComponent;
    },
    slide_scroll: function () {
        return require('../assets/animations/slide/scroll.svg').ReactComponent;
    },
    slide_fade: function () {
        return require('../assets/animations/slide/fade.svg').ReactComponent;
    },
    slide_stack: function () {
        return require('../assets/animations/slide/stack.svg').ReactComponent;
    },
    infoPosition_below: function () {
        return require('../assets/infoPosition/below.svg').ReactComponent;
    },
    infoPosition_above: function () {
        return require('../assets/infoPosition/above.svg').ReactComponent;
    },
    infoPosition_right: function () {
        return require('../assets/infoPosition/right.svg').ReactComponent;
    },
    infoPosition_left: function () {
        return require('../assets/infoPosition/left.svg').ReactComponent;
    },
    infoPosition_onImage: function () {
        return require('../assets/infoPosition/onImage.svg').ReactComponent;
    },
    vertical_top: function () {
        return require('../assets/alignment/vertical/top.svg').ReactComponent;
    },
    alignment_center: function () {
        return require('../assets/alignment/center.svg').ReactComponent;
    },
    vertical_bottom: function () {
        return require('../assets/alignment/vertical/bottom.svg').ReactComponent;
    },
    horizontal_left: function () {
        return require('../assets/alignment/horizontal/left.svg').ReactComponent;
    },
    horizontal_right: function () {
        return require('../assets/alignment/horizontal/right.svg').ReactComponent;
    },
    overlay_expand: function () {
        return require('../assets/animations/overlay/expand.svg').ReactComponent;
    },
    overlay_fadeIn: function () {
        return require('../assets/animations/overlay/fadeIn.svg').ReactComponent;
    },
    overlay_slideUp: function () {
        return require('../assets/animations/overlay/slideUp.svg').ReactComponent;
    },
    overlay_slideRight: function () {
        return require('../assets/animations/overlay/slideRight.svg').ReactComponent;
    },
    overlay_slideDown: function () {
        return require('../assets/animations/overlay/slideDown.svg').ReactComponent;
    },
    overlay_slideLeft: function () {
        return require('../assets/animations/overlay/slideLeft.svg').ReactComponent;
    },
};
//# sourceMappingURL=ProGallery.icons.js.map